//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmailPasswordVendorLogin from '../../../../../common/wizard/EmailPasswordVendorLogin';

export default {
  name: 'LinkDeviceModal',
  components: { EmailPasswordVendorLogin },
  props: ['deviceName', 'error'],
  data() {
    return {
      open: false,
    };
  },
  methods: {
    show() {
      this.open = true;
    },
    close(andCancel) {
      this.open = false;
      if (andCancel) {
        this.$emit('cancel');
      }
    },
    handleOk(e) {
      e.preventDefault();
      this.$emit('ok', e);
    },
  },
};
